module.exports = __webpack_public_path__ + "static/img/xnq0701.fa34549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xnq0701.jpg
// module id = QyeQ
// module chunks = 0